import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-card-view-add-card',
  templateUrl: './card-view-add-card.component.html',
  styleUrls: ['../card-view-simple-card/card-view-simple-card.component.css']
})
export class CardViewAddCardComponent implements OnInit {


  constructor(private router: Router) { }

  ngOnInit() {
  }


}
